import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d60ff30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4d60ff30&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60ff30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d60ff30')) {
      api.createRecord('4d60ff30', component.options)
    } else {
      api.reload('4d60ff30', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d60ff30&scoped=true", function () {
      api.rerender('4d60ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/deliverGoods/freightSet/index.vue"
export default component.exports